import { Injectable } from '@angular/core';
import { EntryMainWorkflowStatusDto } from '@osos/shared/api';

import { FactoryBase } from '../../bases/factory/factory-base';
import { ParserFactory } from '../../services';

import { DataEntryWorkflowStatusPresenterModel } from '@osos/shared/types';
import { EntryWorkFlowStatusParserV1Service } from '../../parsers/data-entry-workflow-status-parser/entry-workflow-status-parser-v1.service';

@Injectable()
export class EntryWorkFlowStatusFactoryService extends FactoryBase<
  EntryMainWorkflowStatusDto,
  DataEntryWorkflowStatusPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: EntryWorkFlowStatusParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: DataEntryWorkflowStatusPresenterModel,
  ): EntryMainWorkflowStatusDto {
    const parser = this.getParser(
      EntryMainWorkflowStatusDto,
      DataEntryWorkflowStatusPresenterModel,
    );
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(
    model: EntryMainWorkflowStatusDto,
  ): DataEntryWorkflowStatusPresenterModel {
    const parser = this.getParser(
      EntryMainWorkflowStatusDto,
      DataEntryWorkflowStatusPresenterModel,
    );
    const result = parser.getPresenterModel(model);
    return result;
  }
}
